import React, { Component } from 'react';

const ContractorsMeetingRegInfo = () => {
	return ( <h1>Contractors Meeting Registration Info</h1> );
}
 
export default ContractorsMeetingRegInfo;